<template>
  <div class="upgrade-overlay">
    <div class="upgrade-content">
      <ion-icon :icon="lockClosedOutline" class="upgrade-icon"></ion-icon>
      <h2>Unlock QuickScreen</h2>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IonIcon } from '@ionic/vue';
import { lockClosedOutline } from 'ionicons/icons';

const props = defineProps<{
  message: string;
}>();
</script>

<style scoped>
.upgrade-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.upgrade-content {
  background: var(--ion-background-color);
  padding: 24px;
  border-radius: 12px;
  text-align: center;
  max-width: 90%;
  width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.upgrade-icon {
  font-size: 48px;
  color: #8E8E93;
  margin-bottom: 16px;
}

h2 {
  margin: 0 0 12px;
  color: var(--ion-text-color);
  font-size: 1.5rem;
  font-weight: 600;
}

p {
  margin: 0;
  color: var(--ion-text-color);
  font-size: 1rem;
  line-height: 1.5;
}
</style> 